import React from 'react';
import { useForm } from 'react-hook-form';
import { NoteInputContext, READ_ONLY_VIEW, EMPTY_NOTE_VIEW, VIEW_MAP } from './NoteInputContext';
import { getPlainTextAndTagsFromHTML } from './NoteInput.helpers';

export const NoteInput = ({
  showCheckMarkButtons,
  hasPermission,
  handleUpdateNote,
  handleSetNote,
  createdBy = '',
  ...props
}) => {
  const { task, note, showEditNote } = props;
  const noteInputContext = NoteInputContext(props);
  const { controller, state, textAreaRef } = noteInputContext;
  const { textValue: inputHtmlText, inputData } = state.toObject();
  const noteText = note?.get('text');
  const { handleSubmit } = useForm();

  const onSubmit = () => {
    const textTyped = inputData.blocks.map(block => block.text).join('');
    if (/^\s*$/.test(textTyped) && !showCheckMarkButtons) {
      textAreaRef.current.focus();
    } else {
      const { plainText, taggedParties } = getPlainTextAndTagsFromHTML(inputHtmlText, inputData);
      if (showEditNote && !showCheckMarkButtons) controller.resetNote();
      else if (plainText) controller.setView(READ_ONLY_VIEW);
      else controller.setView(EMPTY_NOTE_VIEW);
      handleUpdateNote({ task, htmlText: inputHtmlText, taggedParties, plainText });
    }
  };

  const isEmpty = !noteText || noteText.length < 1;
  if (isEmpty && !hasPermission) return null;

  const NoteInputView = VIEW_MAP[state.get('view')];
  return (
    <NoteInputView
      note={note}
      context={noteInputContext}
      onSubmit={handleSubmit(onSubmit)}
      createdBy={createdBy}
      hasPermission={hasPermission}
      showCheckMarkButtons={showCheckMarkButtons}
      handleSetNote={handleSetNote}
    />
  );
};
